import AsyncStorage from '@react-native-async-storage/async-storage';
import { fromPromise } from 'xstate5';

import { DIETARY_PREFERENCES_KEY } from './constants';
import { type AllergenTypes } from './types';

// ─── Hydration ───────────────────────────────────────────────────────────────

export const hydrateDietaryPreferences = fromPromise<void, AllergenTypes>(async (args) => {
  await AsyncStorage.setItem(DIETARY_PREFERENCES_KEY, JSON.stringify(args.input));
});

export const rehydrateDietaryPreferences = fromPromise<AllergenTypes | {}>(async () => {
  const dietaryPreferences = await AsyncStorage.getItem(DIETARY_PREFERENCES_KEY);

  if (!dietaryPreferences) return {};

  return JSON.parse(dietaryPreferences);
});

// ─── Remote Preferences ──────────────────────────────────────────────────────

/**
 * NOTE: External actor
 */
export const fetchCustomerDietaryPreferences = fromPromise<
  AllergenTypes,
  { preferences: AllergenTypes }
>(async () => {
  throw new Error('fetchCustomerDietaryPreferences implementation required');
});

/**
 * NOTE: External actor
 */
export const updateRemotePreferences = fromPromise<void, { pendingPreferences: AllergenTypes }>(
  async (_args) => {
    throw new Error('updateRemotePreferences implementation required');
  },
);
